"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScheduledTaskRequestDTOSchema = exports.ScheduledTaskDTO = exports.ScheduledTaskDTOSchema = exports.ScheduledTaskSchema = exports.ScheduledTaskBaseSchema = void 0;
var zod_1 = require("zod");
var CommonMongoModelFields_1 = require("./lib/CommonMongoModelFields");
exports.ScheduledTaskBaseSchema = zod_1.z.object({
    name: zod_1.z.string(), // Task name (e.g., "Membership upcoming renewal")
    slug: zod_1.z.string(), // Unique identifier (e.g., "membership-upcoming-renewal")
    cronSchedule: zod_1.z.string(), // Cron expression (e.g., "0 0 * * *")
    isActive: zod_1.z.boolean().default(true), // Whether task is enabled/disabled
    emailsEnabled: zod_1.z.boolean().default(true), // Whether emails are enabled for this task
    description: zod_1.z.string().optional(), // Optional description
});
exports.ScheduledTaskSchema = exports.ScheduledTaskBaseSchema.extend(CommonMongoModelFields_1.CommonMongoModelFields);
exports.ScheduledTaskDTOSchema = exports.ScheduledTaskSchema.extend(CommonMongoModelFields_1.CommonModelDTOFields);
exports.ScheduledTaskDTO = {
    convertFromModel: function (model) {
        var dto = {
            _id: model._id.toString(),
            createdAt: model.createdAt,
            updatedAt: model.updatedAt,
            name: model.name,
            slug: model.slug,
            cronSchedule: model.cronSchedule,
            isActive: model.isActive,
            emailsEnabled: model.emailsEnabled,
            description: model.description,
        };
        return dto;
    },
};
exports.ScheduledTaskRequestDTOSchema = exports.ScheduledTaskDTOSchema.extend(__assign({}, CommonMongoModelFields_1.CommonModelRequestDTOFields));
//# sourceMappingURL=ScheduledTask.js.map